export default {"src":"/_next/static/image/public/images/ic_right_green.d287d200dc0d73291c591ac7f06b8a90.svg","height":32,"width":32};